export default "__VITE_ASSET__BhZDMDWu__"